import React from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

const UITableShell = ({
  columns = [],
  toolbar,
  footer,
  renderHeaderCell,
  children,
  customLayout = false,
  paperSx,
  tableContainerSx,
  tableSx,
  bodySx,
  minWidth = 800,
}) => {
  const safeColumns = Array.isArray(columns) ? columns : [];

  return (
    <Paper
      elevation={0}
      sx={{
        flex: 1,
        borderRadius: 2.5,
        border: "1px solid",
        borderColor: "divider",
        borderTop: "3px solid",
        borderTopColor: "primary.main",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        minHeight: 0,
        boxShadow: "0 1px 3px 0 rgba(0,0,0,0.07), 0 1px 2px -1px rgba(0,0,0,0.07)",
        ...paperSx,
      }}
    >
      {toolbar}

      {customLayout ? (
        children
      ) : (
        <TableContainer
          sx={{
            flex: 1,
            overflow: "auto",
            minHeight: 0,
            borderRadius: "0 !important",
            "&::-webkit-scrollbar": { width: 6, height: 6 },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "rgba(148, 163, 184, 0.8)",
              borderRadius: 99,
            },
            "&::-webkit-scrollbar-track": {
              backgroundColor: "transparent",
            },
            ...tableContainerSx,
          }}
        >
          <Table stickyHeader size="small" sx={{ minWidth, width: "100%", ...tableSx }}>
            <TableHead>
              <TableRow>
                {safeColumns.map((column, index, array) =>
                  renderHeaderCell ? (
                    renderHeaderCell(column, index, array)
                  ) : (
                    <TableCell key={column.id || column.field}>{column.label || column.headerName}</TableCell>
                  ),
                )}
              </TableRow>
            </TableHead>
            <TableBody
              sx={{
                "& .MuiTableCell-root": {
                  borderBottom: "1px solid",
                  borderColor: "divider",
                },
                "& .MuiTableRow-root:last-child .MuiTableCell-root": {
                  borderBottom: "none",
                },
                ...bodySx,
              }}
            >
              {children}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      {footer}
    </Paper>
  );
};

export default UITableShell;
